import { getCollectionsForAddressQueryData } from 'api/lib/tokenContracts'
import { parseUnits } from 'hooks/useBalance'
import { Address, TransferAssetTransactionContext } from 'use-towns-client'

import { TransferSchema } from './transferAssetsSchema'
import { isAddress } from './useGetWalletParam'

export function getEthTransferData(args: {
    data: TransferSchema
    onParseError: () => void
}): TransferAssetTransactionContext['data'] {
    const { data, onParseError } = args
    if (!data.recipient) {
        throw new Error('Recipient is required')
    }
    if (!data.ethAmount) {
        throw new Error('ETH amount is required')
    }
    let valueInWei
    try {
        valueInWei = parseUnits(data.ethAmount)
    } catch (error) {
        onParseError()
        return
    }

    return {
        value: valueInWei,
        assetLabel: 'Base ETH',
        recipient: data.recipient,
    }
}

export function getNftTransferData(args: {
    data: TransferSchema
    fromWallet: string | undefined
}): TransferAssetTransactionContext['data'] {
    const { data, fromWallet } = args
    if (!isAddress(data.assetAddressOrIdentifier)) {
        throw new Error('Invalid asset address')
    }
    if (!data.recipient) {
        throw new Error('Recipient is required')
    }
    if (!fromWallet) {
        throw new Error('Wallet is required')
    }

    const tokenMetadata = getCollectionsForAddressQueryData(fromWallet)?.find(
        (t) => t.data.address === data.assetAddressOrIdentifier,
    )

    return {
        contractAddress: data.assetAddressOrIdentifier,
        tokenId: data.tokenId ?? '',
        assetLabel: tokenMetadata?.data.label ?? data.assetAddressOrIdentifier,
        recipient: data.recipient,
        value: undefined,
    }
}

export function getUsdcTransferData(args: {
    data: TransferSchema
    usdcAddress: Address
    onParseError: () => void
}): TransferAssetTransactionContext['data'] {
    const { data, usdcAddress, onParseError } = args
    if (!data.recipient) {
        throw new Error('Recipient is required')
    }
    if (!data.ethAmount) {
        throw new Error('USDC amount is required')
    }

    let amountInSmallestUnit: bigint
    try {
        // USDC has 6 decimals
        amountInSmallestUnit = parseUnits(data.ethAmount, 6)
    } catch (error) {
        onParseError()
        return
    }

    return {
        contractAddress: usdcAddress,
        erc20Amount: amountInSmallestUnit,
        assetLabel: 'USDC',
        recipient: data.recipient,
    }
}
